module.exports = __webpack_public_path__ + "static/media/ledlamp.33553e58.png";